/* Small, defensive UX cleanup. It never changes products, prices or forms. */
(function () {
  function removeEmptyCartPlaceholders() {
    if (window.location.pathname.replace(/\/+$/, '') !== '/cart') return;
    document.querySelectorAll('.ui-test-product-list').forEach(function (list) {
      var hasPlaceholder = Array.prototype.some.call(list.querySelectorAll('h3, p'), function (node) {
        return node.textContent.trim().toLowerCase() === 'product title';
      });
      if (hasPlaceholder) list.remove();
    });
  }

  function observeCartHydration() {
    if (window.location.pathname.replace(/\/+$/, '') !== '/cart') return;
    var observer = new MutationObserver(removeEmptyCartPlaceholders);
    observer.observe(document.body, { childList: true, subtree: true });
    window.setTimeout(function () { observer.disconnect(); }, 5000);
  }

  function markLoaded() {
    document.documentElement.classList.add('tch-final-ui-ready');
  }

  function improveEmptyStates() {
    var emptyStates = document.querySelectorAll('.main-collection-grid__empty');
    if (!emptyStates.length) return;

    var isSearch = window.location.pathname.replace(/\/+$/, '') === '/search' || document.body.classList.contains('template-search');
    emptyStates.forEach(function (empty) {
      var title = empty.querySelector('.main-collection-grid__empty-title');
      if (!title || title.dataset.tchEmptyStateReady) return;

      title.dataset.tchEmptyStateReady = 'true';
      title.textContent = isSearch ? 'No pieces found for this search.' : 'No pieces found in this collection.';

      var copy = empty.querySelector('p');
      if (copy) {
        copy.className = 'tch-empty-state__copy';
        copy.textContent = isSearch
          ? 'Try another material, room or furniture type, or browse all furniture.'
          : 'Try another collection or browse all furniture.';
      }

      if (!empty.querySelector('.tch-empty-state__link')) {
        var link = document.createElement('a');
        link.className = 'tch-empty-state__link';
        link.href = isSearch ? '/collections' : '/collections/all';
        link.textContent = isSearch ? 'Browse collections' : 'Browse all furniture';
        empty.appendChild(link);
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      removeEmptyCartPlaceholders();
      observeCartHydration();
      improveEmptyStates();
      markLoaded();
    }, { once: true });
  } else {
    removeEmptyCartPlaceholders();
    observeCartHydration();
    improveEmptyStates();
    markLoaded();
  }
})();
